













import { Component, Prop, Vue } from "vue-property-decorator";
import { SubItem } from "@/store/catalog/types";

@Component
export default class SubMenu extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<SubItem>;
}
